<template>
  <div>
    <a-modal v-model:visible="visible" title="客户信息" @ok="handleOk" okText="修改" cancelText="取消" :afterClose="closeModal" width="30vw">
      <a-form :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item label="名称" required>
          <a-input v-model:value="inputs.name" />
        </a-form-item>
        <a-form-item label="电话" required>
          <a-input v-model:value="inputs.mobile" />
        </a-form-item>
        <a-form-item label="性别" required>
          <a-select v-model:value="inputs.gender" allowClear>
            <!-- <a-select-option v-for="item in $store.state.areaNameType" :value="item.NAME">{{ item.NAME }}</a-select-option> -->
            <a-select-option value="男">男</a-select-option>
            <a-select-option value="女">女</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="生日" required>
          <a-date-picker v-model:value="inputs.birthday" placeholder="" />
        </a-form-item>
        <a-form-item label="年龄">
          {{age}}
        </a-form-item>
        <a-form-item label="身高(CM)">
          <a-input v-model:value="inputs.height" />
        </a-form-item>
        <a-form-item label="体重(KG)">
          <a-input v-model:value="inputs.weight" />
        </a-form-item>
        <!-- <a-form-item label="职业">
          <a-input v-model:value="inputs.profession" />
        </a-form-item> -->

      </a-form>

    </a-modal>
  </div>
</template>

<script>
import { reactive } from "vue";
import { Add } from "/src/api/role.js";
import medicineSelector from '/src/components/selector/medicineSelector.vue';
import { UpdateCustomer } from "/src/api/medicalRecord.js";
export default {
  components: {
    medicineSelector
  },
  data() {
    return {
      visible: this.modelValue,

      medicine: "",
      inputs: {
        name: undefined,
        mobile: undefined,
        gender: undefined,
        birthday: undefined,
        age: undefined,
        height: undefined,
        weight: undefined,
        profession: undefined,
      },
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
    };
  },
  emits: ['update:modelValue'],
  created() {

  },
  mounted() {
  },
  activated() {
  },
  //获取父元素传值
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    customerInfo: {
      type: Object,
      default: () => { }
    }
  },
  computed: {
    age() {
      //计算年龄
      if (this.inputs.birthday) {
        let birthday = new Date(this.inputs.birthday);
        let nowDate = new Date();
        let age = nowDate.getFullYear() - birthday.getFullYear();
        let m = nowDate.getMonth() - birthday.getMonth();
        if (m < 0 || (m === 0 && nowDate.getDate() < birthday.getDate())) {
          age--;
        }
        return age;
      } else {
        return 0;
      }
    }
  },
  methods: {

    async handleOk() {
      let _this = this;

      let res = await UpdateCustomer({
        id: this.customerInfo.id,
        ...this.inputs
      })
      if (res.errCode == 0) {
        this.$message.success("修改成功");
        this.$emit('update:modelValue', false);
        this.$emit('reSearch');
      } else {
        this.$message.error("修改失败");
      }
    },
    closeModal() {
      this.$emit('update:modelValue', false);
    }
    //初始化data所有数据，并关闭modal
  },
  watch: {
    modelValue(val) {
      this.visible = val
    },
    customerInfo(val) {
      this.inputs = {...val}
    },
  }
};
</script>

<style scoped>
.head {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  align-items: center;
}
.head span {
  font-weight: bold;
  margin-right: 10px;
}
</style>
